import { TaxCreatePage } from '@/features/tax/pages/TaxCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/tax/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["tax.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TaxCreatePage,
})
